const allOpenChanges = (changes) => {
    const list = changes.filter((cur)=>{
		return cur.is_resolved === false;
    });
    return list;
}

const allAnimalChanges = (animal,changes) => {
    const changesForAnimal = changes.filter((cur)=>{
        return cur.animals.includes(animal.id);
    });
    return changesForAnimal;
}

const allOpenAnimalChanges = (animal,changes) => {
    const openChangesForAnimal = changes.filter((cur)=>{
        return cur.is_resolved === false && cur.animals.includes(animal.id);
    });
    return openChangesForAnimal;
}

const sortDescStart = (a,b) => {
    return b.start.valueOf() - a.start.valueOf();
}

const sortAscStart = (a,b) => {
    return a.start.valueOf() - b.start.valueOf();
}

export {allOpenChanges, allAnimalChanges, allOpenAnimalChanges, sortDescStart, sortAscStart};